import React from "react";
import useStore from "../../../context/useStore";
import { authActions } from "../../../context/actions/authActions";
import "./coquille.scss";

const capitaliser = (mot) => (mot ? mot.charAt(0).toUpperCase() + mot.slice(1).toLowerCase() : "");

// En-tête du portail : barre espoar-blue, logo, et pour un allocataire
// connecté son nom et « Se déconnecter » en toutes lettres. Plus de menu
// repliable Bootstrap (il n'avait aucune entrée). Les écrans hors connexion
// portent leur propre volet marque et masquent cette barre (PageHorsConnexion).
const Header = () => {
  const [state, dispatch] = useStore();
  const actions = authActions(state, dispatch);
  const { isAuthenticated, user } = state.auth;

  return (
    <header className="en-tete">
      <div className="en-tete__barre">
        <span className="en-tete__marque">
          <img src="/assets/logo-espoar-new.png" alt="ESPOAR" height="32" />
          <span className="en-tete__espace">Espace allocataire</span>
        </span>
        {isAuthenticated && (
          <div className="en-tete__compte">
            <span className="en-tete__nom">
              {capitaliser(user.firstname)} {(user.lastname || "").toUpperCase()}
            </span>
            <button type="button" className="en-tete__deconnexion" onClick={actions.logoutUser}>
              <i className="fa fa-sign-out-alt" aria-hidden="true" />
              <span>Se déconnecter</span>
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
